import { Box, Container, Typography } from "@mui/material";
import SEO from "../components/Common/SEO";


export default function TermsConditions() {
  return (
    <>
      <SEO page="terms" />

      <Box
        sx={{
          background:
            "linear-gradient(180deg,#F8FBFF 0%,#FFFFFF 100%)",

          minHeight: "100vh",

          py: {
            xs: 6,
            md: 10,
          },
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              p: {
                xs: 3,
                md: 6,
              },

              borderRadius: "30px",

              background: "#fff",

              border: "1px solid rgba(0,87,255,.08)",

              boxShadow:
                "0 20px 60px rgba(0,87,255,.08)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,

                color: "#07122F",

                fontSize: {
                  xs: "34px",
                  md: "56px",
                },
              }}
            >
              Terms & Conditions
            </Typography>

            <Typography
              sx={{
                color: "#64748B",

                mt: 1,

                mb: 5,
              }}
            >
              Last Updated: June 2026
            </Typography>

            {[
              {
                title: "Services",
                text:
                  "Comet Cleaners provides dry cleaning, laundry service, wedding dress care, alterations, rug cleaning, shoe repair, handbag care, pickup and delivery services.",
              },

              {
                title: "Customer Responsibilities",
                text:
                  "Customers are responsible for checking garment pockets and informing us about stains, damages, or special care requirements.",
              },

              {
                title: "Garment Care",
                text:
                  "While every reasonable effort is made to care for garments, Comet Cleaners is not responsible for manufacturer defects, normal wear and tear, fabric aging, or improper care labels.",
              },

              {
                title: "Pickup & Delivery",
                text:
                  "Pickup and delivery schedules are estimates and may vary due to weather, traffic, or operational circumstances.",
              },

              {
                title: "Pricing",
                text:
                  "Prices may change without notice. Final pricing may vary depending on garment condition, fabric type, and requested services.",
              },

              {
                title: "Payments",
                text:
                  "Payment is due upon completion of services unless otherwise agreed in writing.",
              },

              {
                title: "Limitation of Liability",
                text:
                  "Liability for loss or damage shall not exceed the fair value of the item as determined by applicable laws and industry standards.",
              },

              {
                title: "Website Usage",
                text:
                  "Users agree not to misuse the website or attempt unauthorized access to systems, services, or data.",
              },

              {
                title: "Policy Updates",
                text:
                  "Comet Cleaners reserves the right to modify these terms at any time without prior notice.",
              },

              {
                title: "Contact Information",
                text:
                  "Comet Cleaners, 15 Westney Rd N Unit 4A, Ajax, Ontario L1T 1P5. Email: cometcleaners5@gmail.com",
              },
            ].map((item, index) => (
              <Box key={index} sx={{ mb: 4 }}>
                <Typography
                  sx={{
                    fontWeight: 800,

                    color: "#07122F",

                    mb: 1,

                    fontSize: {
                      xs: "20px",
                      md: "26px",
                    },
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    color: "#64748B",

                    lineHeight: 1.9,
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </>
  );
}
